<template>
  <div class="tabs">
    <span
      v-for="tab in tabs"
      :key="tab.index"
      class="tab"
      :class="{ active: tab.value === selectedTab }"
      @click="selectTab(tab.value)"
    >
      {{ tab.label }}
      <span v-if="tab.amount">({{ tab.amount }})</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseCardTabs',

  props: {
    tabs: Array,
    selectedTab: String,
  },
  methods: {
    selectTab(tab) {
      this.$emit('selectTab', tab);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
  border-radius: 1rem 1rem 0 0;
  overflow: auto;
}

.tab {
  padding: 1rem 0;
  background: var(--gray-lighter);
  cursor: pointer;
  transition: 0.5s;
  &:hover {
    color: var(--company-main-primary);
  }
}

.active {
  font-weight: bold;
  background: var(--color-white);
  color: var(--company-main-primary);
}
</style>
